module.exports = __webpack_public_path__ + "static/assets/0502dd0a0a126f965b003d2081bec860.png";